// QuestionPanel — Phase 2 / Step C-3.3 Pass 1 shim. See
// shared/widgets/scenario_os/QuestionPanel.jsx for the canonical
// implementation. The shared widget accepts an optional `eventBus`
// prop in place of the learner-app singleton import; we wire the
// singleton here so SessionPage and other in-tree callers continue
// working without changes.
import React from 'react';
import EventBus from '../../game/EventBus';
import QuestionPanelShared from '../../../../shared/widgets/scenario_os/QuestionPanel.jsx';

export default function QuestionPanel(props) {
  return <QuestionPanelShared eventBus={EventBus} {...props} />;
}
